import { combineReducers } from 'redux';
import { i18n } from './i18n.reducer';
import { user } from './user.reducer';


const rootReducer = combineReducers({
    i18n,
    user
});

export default rootReducer;
